import { MDBBtn, MDBCol, MDBModalBody, MDBModalFooter, MDBRow } from "mdbreact";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "reactstrap";

import { ProtectionOfPersonalDataText } from "../PrivacyTexts";
import * as privacyActions from "../../redux/privacy/actions";

function ProtectionOfPersonalDataModal() {
  const dispatch = useDispatch();
  const privacyUiState = useSelector(state => state.privacy.ui);

  const toggleModal = () => {
    const status = !privacyUiState.isProtectionOfPersonalDataModalOpen;
    status
      ? dispatch(privacyActions.showProtectionOfPersonalDataModal())
      : dispatch(privacyActions.hideProtectionOfPersonalDataModal());
  };

  useEffect(() => {
    return () => {
      if (privacyUiState.isProtectionOfPersonalDataModalOpen === true)
        dispatch(privacyActions.hideProtectionOfPersonalDataModal());
    };
  }, [dispatch, privacyUiState.isProtectionOfPersonalDataModalOpen]);

  return (
    <Modal
      size="lg"
      keyboard={false}
      backdrop="static"
      scrollable
      isOpen={privacyUiState.isProtectionOfPersonalDataModalOpen}
      toggle={toggleModal}>
      <MDBModalBody>
        <MDBRow>
          <MDBCol md="12" className="p-4 text-justify">
            <ProtectionOfPersonalDataText />
          </MDBCol>
        </MDBRow>
      </MDBModalBody>
      <MDBModalFooter className="justify-content-center align-items-center">
        <MDBBtn color="blue-grey" onClick={toggleModal}>
          KİŞİSEL VERİLERİN KORUNMASI VE SAKLANMASI POLİTİKASINI OKUDUM VE ONAYLIYORUM
        </MDBBtn>
      </MDBModalFooter>
    </Modal>
  );
}

export default React.memo(ProtectionOfPersonalDataModal);
